import React, { useEffect, useRef } from 'react';
import { getToken } from '../../services/Auth';
import { useHistory } from "react-router-dom";

function CoursePlayer(props) {
    let history = useHistory();
    let iframeRef = useRef(null);
    useEffect(() => {
        let url = `https://captivateprime.adobe.com/app/player?lo_id=${props.history.location.state.cid}&access_token=${(getToken()).access_token}`;
        if (props.history.location.state.mid) {
            url = url + `&module_id=${props.history.location.state.mid}`;
        }
        iframeRef.current.src = url;
        window.addEventListener("message", function closePlayer(event) {
            //console.log(event);
            if (event.data === "status:close") {
                window.removeEventListener("message", closePlayer);
                history.push({
                    pathname: props.history.location.state.goBackUrl,
                    state: {
                        cid: props.history.location.state.cid
                    }
                });
            }
        });

    }, []);
    return (
        <React.Fragment>
            <iframe
                ref={iframeRef}
                // src={}
                scrolling="no"
                id="pplayer_iframe"
                name="pfplayer_frame"
                allowtransparency="true"
                webkitallowfullscreen="true"
                mozallowfullscreen="true"
                msallowfullscreen="true"
                allowfullscreen="true"
                title="Player"
                style={{
                    display: "block",       /* iframes are inline by default */
                    background: "#000",
                    border: "none",        /* Reset default border */
                    height: "100vh",        /* Viewport-relative units */
                    width: "100vw"
                }}
            >
            </iframe>
        </React.Fragment>
    );
}

export default CoursePlayer;